import { render, staticRenderFns } from "./InsertEmailDialog.vue?vue&type=template&id=3ffd3dd2&scoped=true&"
import script from "./InsertEmailDialog.vue?vue&type=script&lang=js&"
export * from "./InsertEmailDialog.vue?vue&type=script&lang=js&"
import style0 from "./InsertEmailDialog.vue?vue&type=style&index=0&id=3ffd3dd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffd3dd2",
  null
  
)

export default component.exports